import BaseService from "../base.service";

class SurveySubjectGroupService extends BaseService {
  constructor() {
    super("survey-subject-groups");
  }
}

export default new SurveySubjectGroupService();
